const invitations = {
  pageName: 'Invitaciones',

  toast: {
    error: {
      default: 'No se pudo completar la operación.',
    },
    success: {
      delete: {
        default: 'Las invitaciones se eliminaron correctamente',
      },
      resend: {
        default: 'Las invitaciones se han reenviado correctamente.',
      },
      create: {
        default: '¡Éxito! Invitación enviada correctamente.',
      }
    },
  },

  table: {
    headers: {
      status: 'Estado',
      email: 'Correo electrónico',
      role: 'Función',
      invitedBy: 'Invitado por',
    },
    actions: {
      delete: 'Eliminar',
      resend: 'Reenviar',
    },
    filters: {
      status: 'Estado',
    }
  },

  form: {
    headers: {
      personalDetails: 'Detalles personales',
      roles: 'Roles de usuario',
    },
    fields: {
      firstName: 'Nombre',
      lastName: 'Apellido',
      name: 'Nombre',
      phone: 'Telefono',
      email: 'Correo electrónico',
      role: 'Función',
      site: 'Sitio',
    },
    select: 'Seleccionar',
    buttons: {
      addAccess: 'Añadir sitio',
      sendInvitation: 'Enviar Invitación',
    },
  },

  deleteModal: {
    header: 'Eliminar invitaciones',
    body: 'Está a punto de eliminar {{num}} invitaciones.',
  },

  resendModal: {
    header: 'Reenviar invitaciones',
    body: 'Está a punto de reenviar {{num}} invitaciones.',
  },

  inviteModal: {
    header: 'Invitar usuario',
    description: {
      new: 'Introduzca la dirección de correo electrónico y seleccione las funciones preferidas.',
      existing: 'Seleccione los Sitios y las funciones preferidas.',
    },
  },

  status: {
    pend: 'Pendiente',
    accepted: 'Aceptado',
    expired: 'Expirado',
  },

  isCompanyAdmin: 'Administrador de la empresa',
};

export default invitations;
